<template>
    <el-dialog
      title="月卡车辆导入"
      :visible.sync="childdialogshow"
      width="40%"
      :before-close="cancel"
    >
      <div style="width: 95%">
        <div style="text-align: right">
          <el-link
            href="https://tc.mtfpos.com/upfiles/月卡车辆导入模板.xls"
            type="primary"
            target="_blank"
            >下载月卡导入模板</el-link
          >
        </div>
        <h4 style="border-bottom: 1px solid #e8e8e8"></h4>
        <el-form
          :model="createform"
          ref="createform"
          :rules="rules"
          class="dialoForm-form"
          label-width="120px"
          style="width: 95%"
        >
          <el-form-item label="导入模式：" label-width="120px">
            <el-radio v-model="createform.importmode" :label="1"
              >【有效导入】只导入有效的数据</el-radio
            >
            <el-radio v-model="createform.importmode" :label="2"
              >【全部导入】数据有错都不导入</el-radio
            >
          </el-form-item>
          <el-form-item label="选择Excel：">
            <el-upload
              ref="upload"
              accept=".xls,.xlsx"
              action="#"
              :auto-upload="false"
              :multiple="false"
              :file-list="fileList"
              :before-upload="beforeUpload"
              :http-request="uploadHttpRequest"
              :on-remove="fileRemove"
              :on-change="fileChange"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div class="el-upload__tip" slot="tip">
                一次只能上传一个xls/xlsx文件，且不超过3M
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <h4 style="border-bottom: 1px solid #e8e8e8"></h4>
        <div style="text-align: right">
          <p>导入资料填写时，时间格式为2022-01-01，车牌号格式为川A88888。</p>
          <p>导入出错时，系统会返回出错的表格。</p>
          <p>导入数据多时，等待时间会较长，请耐心等待。</p>
        </div>
        <div slot="footer" style="text-align: right" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="submitUpload()">导 入</el-button>
        </div>
      </div>
    </el-dialog>
  </template>
  <script>
  import { importd } from "@/api/monthcardcar";
  export default {
    name: "mouthcarimport",
    props: {
      dialogshow: {
        required: true,
        type: Boolean,
      },
    },
    computed: {
      childdialogshow: {
        get() {
          return this.dialogshow;
        },
        set(val) {
          this.$emit("update:dialogshow", val);
        },
      },
    },
    created() {
    },
    data() {
      return {
        createform: {
          file: "",
          autoupdate: true,
          importmode: 1,
        },
        limitNum: 1, // 上传excell时，同时允许上传的最大数
        fileList: [], // excel文件列表
        rules: {
          UnitName: [
            { required: true, message: "单位名称不能为空", trigger: "blur" },
            {
              max: 6,
              message: "单位长度最多不超过6个，请重新输入",
              trigger: "blur",
            },
          ],
        },
      };
    },
    methods: {
      save() {
        this.$refs.createform.validate((valid) => {
          if (valid) {
            if (!this.isedit) {
              createunit(this.createform).then((res) => {
                this.$message({
                  message: "新增成功！",
                  type: "success",
                });
                this.childdialogshow = false;
                this.$emit("importcomplete");
              });
            } else {
              editunit(this.createform).then((res) => {
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
                this.childdialogshow = false;
                this.$emit("importcomplete");
              });
            }
          }
        });
      },
      cancel() {
        this.$emit("cancelimportcomplete");
      },
      // 自定义上传方法，param是默认参数，可以取得file文件信息，具体信息如下图
      uploadHttpRequest(param) {
        const formData = new FormData(); //FormData对象，添加参数只能通过append('key', value)的形式添加
        formData.append("file", param.file); //添加文件对象
        formData.append("autoupdate", this.createform.autoupdate);
        formData.append("autocreategrade", this.createform.autocreategrade);
        formData.append("importmode", this.createform.importmode);
        importd(formData).then((res) => {
          if (res.importstate === 1) {
            this.$message({
              message: `导入成功`,
              type: "success",
            });
            this.childdialogshow = false;
            this.$emit("importcomplete");
          }
          if (res.importstate === 2) {
            this.$alert(
              `部分导入成功,导入数据${res.successcount}条，失败${res.errorcount}条！`,
              "提示",
              {
                confirmButtonText: "下载错误信息Excel",
                callback: (action) => {
                  if (action == "confirm") {
                    window.open("https://tc.mtfpos.com" + res.errorfileurl);
                  }
                },
              }
            );
          }
        });
      },
      // 点击上传：手动上传到服务器，此时会触发组件的http-request
      submitUpload() {
        this.$refs.upload.submit();
      },
      // 文件发生改变
      fileChange(file, fileList) {
        if (fileList.length > 0) {
          this.fileList = [fileList[fileList.length - 1]]; // 展示最后一次选择的文件
        }
      },
      // 移除选择的文件
      fileRemove(file, fileList) {
        if (fileList.length < 1) {
          this.uploadDisabled = true; //未选择文件则禁用上传按钮
        }
      },
    },
  };
  </script>